import { render, staticRenderFns } from "./blockup.vue?vue&type=template&id=f1741950&scoped=true&"
import script from "./blockup.vue?vue&type=script&lang=js&"
export * from "./blockup.vue?vue&type=script&lang=js&"
import style0 from "./blockup.vue?vue&type=style&index=0&id=f1741950&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1741950",
  null
  
)

export default component.exports